export class BypassAuthIpEmailInfo {
    emailList: string;
    ipAddressList: string;
  }
  